<app-one-section-layout [paddingLeft]="'28px'">
    <ng-template #section>
        <h1 class="section">Options</h1>

        <div class="integrations-container">
            <app-integration-card
                *ngFor="let item of integrations$ | async"
                [integration]="item"
                [isNew]="false"
                [status]="getStatus(item)"
                (delete)="onDeleteIntegration(item)"
                (submit)="onSubmit($event, false)"
            >
            </app-integration-card>
            <app-integration-card
                *ngFor="let item of integrationDrafts$ | async"
                [integration]="item"
                status="Not created"
                [isNew]="true"
                (delete)="onDeleteDraftIntegration(item)"
                (submit)="onSubmit($event, true)"
            >
            </app-integration-card>
        </div>

        <app-custom-button
            color="primary"
            text="Add Integration"
            type="link"
            icon="add"
            (buttonClick)="onAddIntegration()"
        >
        </app-custom-button>
    </ng-template>
</app-one-section-layout>
